import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { reverse } from 'utilities/routes'
import { NAME as ROUTE_FIND_ACTIVITY } from 'views/FindActivity/constants'
import { NAME as ROUTE_LOGIN } from 'views/Login/constants'
import { NAME as ROUTE_PROFILE } from 'views/Profile/constants'
import { ROUTE_LOGOUT } from 'state/routes'

import Link from 'components/Link'
import userIcon from 'assets/user-icon.png'

import styles from './styles.css'

class AccountNav extends Component {
  static propTypes = {
    className: PropTypes.string,
    account: PropTypes.oneOfType([
      PropTypes.bool.isRequired,
      PropTypes.object.isRequired,
    ]),
  }

  static defaultProps = {
    className: '',
    account: false,
  }

  getClassName() {
    return classnames(styles.root, this.props.className)
  }

  render() {
    const { account } = this.props
    const figureClassName = classnames(styles.figure, {
      [styles.figureBlank]: !account || !account.image,
    })
    const accountContent = (
      <React.Fragment>
        <span className={styles.name}>
          {account ? account.name : 'Logga in'}
        </span>
        <figure className={figureClassName}>
          <img
            className={styles.avatar}
            src={userIcon}
            alt=""
            // Override default image attributes if passed
            {...(account ? account.image : {})}
          />
        </figure>
      </React.Fragment>
    )

    return (
      <nav className={this.getClassName()}>
        {account ? (
          <button className={styles.head}>{accountContent}</button>
        ) : (
          <Link href={reverse(ROUTE_LOGIN)} className={styles.head}>
            {accountContent}
          </Link>
        )}

        {account && (
          <ul className={styles.subnav}>
            <li>
              <Link href={reverse(ROUTE_FIND_ACTIVITY)}>Hitta aktivitet</Link>
            </li>
            <li>
              <Link href={reverse(ROUTE_PROFILE)}>Min sida</Link>
            </li>
            <li>
              <Link href={reverse(ROUTE_LOGOUT)}>Logga ut</Link>
            </li>
          </ul>
        )}
      </nav>
    )
  }
}

export default AccountNav



// WEBPACK FOOTER //
// ../source/components/AccountNav/index.js